import { theme } from '@dot/design-system';
import { default as QR } from 'qrcode';
import { useEffect, useRef, useState } from 'react';

type Props = {
  onError: (error: Error) => void;
  text?: string;
};

export function useQrCode({ onError, text }: Props) {
  const [qrCode, setQrCode] = useState<string | null>(null);

  const onErrorRef = useRef<(error: Error) => void>(onError);

  useEffect(() => {
    onErrorRef.current = onError;
  });

  useEffect(() => {
    async function generateQRCode() {
      if (!text) {
        return;
      }

      try {
        const url = await QR.toDataURL(text, {
          color: {
            dark: theme.colors.oxfordBlue[100],
            light: '#0000',
          },
          errorCorrectionLevel: 'L',
        });

        setQrCode(url);
      } catch (err) {
        if (err instanceof Error) {
          onErrorRef.current(err);
        } else {
          onErrorRef.current(new Error(String(err)));
        }
      }
    }

    generateQRCode();
  }, [text]);

  return {
    qrCode,
  } as const;
}
